import React from "react"
import { FooterIcons } from "./FooterIcons"
import * as S from "./Styled"
import { useWindowDimensions } from "../../hooks/useWindowDimensions"

export const Footer = () => {
  const { width } = useWindowDimensions()
  return (
    <S.Footer>
      {width > 768 ? (
        "Designed by Kida Hsu in 2020. All rights reserved."
      ) : (
        <>
          Designed by Kida Hsu in 2020. <br /> All rights reserved.
        </>
      )}

      <FooterIcons />
    </S.Footer>
  )
}
